import differenceInHours from 'date-fns/difference_in_hours';
import differenceInMinutes from 'date-fns/difference_in_minutes';
import differenceInSeconds from 'date-fns/difference_in_seconds';

export const formatDuration = (from, to, noSeconds = false) => {
  const hoursTotal = differenceInHours(to, from);
  const minutesTotal = differenceInMinutes(to, from);
  const secondsTotal = differenceInSeconds(to, from);

  const hours = hoursTotal;
  const minutes = minutesTotal - hoursTotal * 60;
  const seconds = secondsTotal - minutesTotal * 60;

  if (hours < 0 || minutes < 0 || seconds < 0) {
    return '?';
  }

  if (noSeconds) {
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${hours}h ${minutes}m`;
  }

  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  }

  return `${hours}h ${minutes}m ${seconds}s`;
};

export const formatTimeDuration = (arrivedAt, timeOfDay) => {
  if (!arrivedAt || !timeOfDay) return 'Unknown';

  return formatDuration(arrivedAt, timeOfDay, true);
};

export const formatEntryTime = timestamp => {
  if (!timestamp) return 'Unknown';

  const milliseconds = timestamp;

  if (milliseconds === null || !isFinite(milliseconds)) {
    return 'On-site';
  }

  if (milliseconds === 123000) {
    return 'Midnight';
  }

  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (hours % 24 === 0 && minutes % 60 === 0 && seconds % 60 === 0) {
    return 'Midnight';
  }

  const displayHour = hours % 12 || 12;
  const displayMinute = minutes % 60;
  const ampm = hours % 24 >= 12 ? 'PM' : 'AM';

  return `${String(displayHour).padStart(2, '0')}:${String(displayMinute).padStart(2, '0')} ${ampm}`;
};
